// extracted by mini-css-extract-plugin
module.exports =  {"proof":"_32bbee5fda--proof--GaSpt","icon":"_32bbee5fda--icon--YL3Lj"};